import { useState, useContext } from 'react';
import { Routes, Navigate, Route, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getRelativePath } from 'helpers/utils';
import DonationConfig from './DonationConfig';
import paths from 'routes/paths';
import Payment from './Payment';
import AuthContext from 'context/authContext';
import { GIFT_AID_STATUS_UNCLAIMED } from 'components/gift-aid/unclaimed-transactions';
import { useDonors } from 'hooks/useDonors';
import { useCreateOrder } from 'hooks/useStripePayments';

function CreateDonation() {
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const { organization, selectedBranchId } = useContext(AuthContext);
  const { createOrderAsync, isCreating: loading } = useCreateOrder();

  const { donors: donorsData } = useDonors();

  const onSubmitDonationConfig = data => {
    setData(data);

    const {
      donorId,
      donationItems,
      subtotal,
      transactionFees,
      total,
      settings
    } = data;
    // donorsData.donars.forEach(element => {
    //   if (element.id === donorId) {
    //     element.email.forEach(email => {
    //       if (email.isPrimary === true) {
    //         donorEmail = email.email;
    //       }
    //     });
    //   }
    // });

    const giftAidData = {
      data: {
        amount: total * 0.25,
        donar_id: donorId,
        status: GIFT_AID_STATUS_UNCLAIMED
      }
    };
    setData({
      donorId,
      donationItems,
      subtotal,
      transactionFees,
      total,
      settings,
      organization: organization.id,
      donorsData,
      giftAidData
      // donorEmail
    });
  };

  const onPay = async paymentMethodId => {
    try {
      const {
        donorId,
        donationItems,
        subtotal,
        transactionFees,
        total,
        settings,
        giftAidData
      } = data;

      const orderDetails = donationItems.map(
        ({ amount, values, type, packageId, donationLocationIds }) => ({
          amount,
          billing_condition: values.billingCondition,
          donation_type_id: type,
          package_id: packageId,
          location_id_list: donationLocationIds?.length
            ? donationLocationIds
            : null
        })
      );

      const isRecurring = orderDetails.some(item => item.billing_condition === 'monthly');

      const response = await createOrderAsync({
        donorId: donorId,
        donorObject: data.donorObject || null,
        branchId: selectedBranchId,
        orderDetails: orderDetails,
        paymentMethodId: paymentMethodId,
        subtotal,
        transactionFees: settings.coverTransactionFee ? transactionFees : 0,
        donationAmount: total,
        giftAidEligible: settings.giftAid,
        giftAids: settings.giftAid ? giftAidData : null,
        isRecurring,
        donationSource: 'phone'
      });

      if (response.message === 'success') {
        navigate('/success');
      } else {
        navigate('/failure');
      }
    } catch (error) {
      toast.error('Something went wrong');
      console.log(error);
      navigate('/failure');
    }
  };

  return (
    <Routes>
      <Route
        path={getRelativePath(paths.configNewDonation, paths.addNewDonation)}
        element={
          <DonationConfig onSubmit={onSubmitDonationConfig} loading={loading} />
        }
      />
      <Route
        path={getRelativePath(paths.payNewDonation, paths.addNewDonation)}
        element={<Payment onPay={onPay} loading={loading} data={data} />}
      />
      <Route
        path="*"
        element={
          <Navigate
            to={getRelativePath(paths.configNewDonation, paths.addNewDonation)}
            replace
          />
        }
      />
    </Routes>
  );
}

export default CreateDonation;
